import React, { Component } from "react";
import { Row, Typography, Spin } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import GenericOnClickModal from "./genericOnClickModal";
import { backendGet } from "../../helpers/callBackend";
import CircularProgress from '@mui/material/CircularProgress';

const { Link } = Typography;

let arpariAccountManagerData = {};

class GetHelpModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountManagerData: arpariAccountManagerData,
      loading: true,
      modalMounted : false,
    };
  }

  fetchAccountManagerDetails = () => {
    backendGet(this, "/api/account-manager/", {}, "loading", (s, d) => {
      s["accountManagerData"] = d.data;
      s["loading"] = false;
      const data = JSON.stringify(d.data);
      localStorage.setItem("arpariAccountManagerData", data);
      return s;
    });
  }

  componentDidUpdate = () => {
    if(this.state.modalMounted) {
      this.fetchAccountManagerDetails(); 
      this.setState({modalMounted : false});
    }
  }

  componentDidMount = () => {
    const accountManagerDataObject = this.state.accountManagerData;
    // TODO: this isn't working
    if(Object.keys(accountManagerDataObject).length !== 0) {
       this.setState({loading : false});
       return;
    } 
    this.setState({modalMounted : true});
  };

  render() {
    return (
      <GenericOnClickModal
        size="sm"
        button={
          <div style={{ color: "#595959" }}>
            <PhoneOutlined />
            <span style={{ marginLeft: 12 }}>Get Help</span>
          </div>
        }
        modalTitle={"Account Manager Info"}
        modalBody={
          <>
            {!this.state.loading ? (
              <>
                <Row><p>Full Name: <b>{this.state.accountManagerData?.full_name}</b></p></Row>
                <Row>
                  <p>
                  Email:&nbsp;
                  <Link href={"mailto:" + this.state.accountManagerData?.email}>
                    {this.state.accountManagerData?.email}
                  </Link>
                  </p>
                </Row>
                <Row>
                  <p>
                  Phone:&nbsp;
                  <Link href={"tel:" + this.state.accountManagerData?.phone}>
                    {this.state.accountManagerData?.phone}
                  </Link>
                  </p>
                </Row>
              </>
            ) : (
              <p>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
  <CircularProgress />
</div>
              </p>
            )}
          </>
        }
      />
    );
  }
}

export default GetHelpModal;
